import {ModulePrimaryAttachment} from "../../shared/models/static-data.model";

export const SET_INSURANCE_COMPANY_LIST = "SET_INSURANCE_COMPANY_LIST";
export const GET_INSURANCE_COMPANY_LIST = "GET_INSURANCE_COMPANY_LIST";

export const SET_SAMPLE_COLLECTION_DEVICE_LIST = "SET_SAMPLE_COLLECTION_DEVICE_LIST";
export const GET_SAMPLE_COLLECTION_DEVICE_LIST = "GET_SAMPLE_COLLECTION_DEVICE_LIST";

export const GET_REPORT_TYPE_LIST = "GET_REPORT_TYPE_LIST";
export const SET_REPORT_TYPE_LIST = "SET_REPORT_TYPE_LIST";
export const SET_INSURANCE_PLAN_LIST = "SET_INSURANCE_PLAN_LIST";
export const GET_INSURANCE_PLAN_LIST = "GET_INSURANCE_PLAN_LIST";

export const SET_RELATION_SHIP_LIST = "SET_RELATION_SHIP_LIST";
export const GET_RELATION_SHIP_LIST = "GET_RELATION_SHIP_LIST";

export const SET_ETHNICITY_LIST = "SET_ETHNICITY_LIST";
export const GET_ETHNICITY_LIST = "GET_ETHNICITY_LIST";

export const SET_RACE_LIST = "SET_RACE_LIST";
export const GET_RACE_LIST = "GET_RACE_LIST";

export const GET_PREFIX_LIST = "GET_PREFIX_LIST";
export const SET_PREFIX_LIST = "SET_PREFIX_LIST";

export const GET_SUFFIX_LIST = "GET_SUFFIX_LIST";
export const SET_SUFFIX_LIST = "SET_SUFFIX_LIST";

export const GET_MARITAL_STATUS_LIST = "GET_MARITAL_STATUS_LIST";
export const SET_MARITAL_STATUS_LIST = "SET_MARITAL_STATUS_LIST";

export const GET_FACILITY_TYPES = "GET_FACILITY_TYPES";
export const SET_FACILITY_TYPES = "SET_FACILITY_TYPES";

export const GET_USER_LIST = "GET_USER_LIST";
export const SET_USER_LIST = "SET_USER_LIST";

export const GET_ACCOUNT_EXECUTIVE_LIST = "GET_ACCOUNT_EXECUTIVE_LIST";
export const SET_ACCOUNT_EXECUTIVE_LIST = "SET_ACCOUNT_EXECUTIVE_LIST";

export const GET_PAYOR_MIX_LIST = "GET_PAYOR_MIX_LIST";
export const SET_PAYOR_MIX_LIST = "SET_PAYOR_MIX_LIST";

export const GET_ACCOUNT_PREFERENCES = "GET_ACCOUNT_PREFERENCES";
export const SET_ACCOUNT_PREFERENCES = "SET_ACCOUNT_PREFERENCES";

export const GET_FACILITY_LIST_LITE = "GET_FACILITY_LIST_LITE";
export const SET_FACILITY_LIST_LITE = "SET_FACILITY_LIST_LITE";

export const GET_LOCATION_LIST_LITE = "GET_LOCATION_LIST_LITE";
export const SET_LOCATION_LIST_LITE = "SET_LOCATION_LIST_LITE";

export const GET_ALL_LOCATION_LIST_LITE = "GET_ALL_LOCATION_LIST_LITE";
export const SET_ALL_LOCATION_LIST_LITE = "SET_ALL_LOCATION_LIST_LITE";

export const GET_LAB_LIST_LITE = "GET_LAB_LIST_LITE";
export const SET_LAB_LIST_LITE = "SET_LAB_LIST_LITE";

export const GET_TEST_LIST_LITE = "GET_TEST_LIST_LITE";
export const SET_TEST_LIST_LITE = "SET_TEST_LIST_LITE";

export const GET_EXPRESSIONS_LIST_LITE = "GET_EXPRESSIONS_LIST_LITE";
export const SET_EXPRESSIONS_LIST_LITE = "SET_EXPRESSIONS_LIST_LITE";

export const GET_TEST_ORDER_STATUS = "GET_TEST_ORDER_STATUS";
export const SET_TEST_ORDER_STATUS = "SET_TEST_ORDER_STATUS";

export const GET_TEST_PANEL_STATUS = "GET_TEST_PANEL_STATUS";
export const SET_TEST_PANEL_STATUS = "SET_TEST_PANEL_STATUS";

export const GET_FACILITY_STATUS = "GET_FACILITY_STATUS";
export const SET_FACILITY_STATUS = "SET_FACILITY_STATUS";

export const GET_LOCATION_STATUS = "GET_LOCATION_STATUS";
export const SET_LOCATION_STATUS = "SET_LOCATION_STATUS";

export const GET_LAB_STATUS = "GET_LAB_STATUS";
export const SET_LAB_STATUS = "SET_LAB_STATUS";

export const GET_PHYSICIAN_LIST_LITE = "GET_PHYSICIAN_LIST_LITE";
export const SET_PHYSICIAN_LIST_LITE = "SET_PHYSICIAN_LIST_LITE";

export const GET_CITY_LIST_LITE = "GET_CITY_LIST_LITE";
export const SET_CITY_LIST_LITE = "SET_CITY_LIST_LITE";

export const SET_BILLING_MODE_LIST = "SET_BILLING_MODE_LIST";
export const GET_BILLING_MODE_LIST = "GET_BILLING_MODE_LIST";

export const SET_SAMPLE_STATUS_LIST = "SET_SAMPLE_STATUS_LIST";
export const GET_SAMPLE_STATUS_LIST = "GET_SAMPLE_STATUS_LIST";

export const SET_SAMPLE_TYPES_LIST = "SET_SAMPLE_TYPES_LIST";
export const GET_SAMPLE_TYPES_LIST = "GET_SAMPLE_TYPES_LIST";

export const SET_PANEL_CODE_LIST = "SET_PANEL_CODE_LIST";
export const GET_PANEL_CODE_LIST = "GET_PANEL_CODE_LIST";

export const SET_EQUIPMENT_TYPE_LIST = "SET_EQUIPMENT_TYPE_LIST";
export const GET_EQUIPMENT_TYPE_LIST = "GET_EQUIPMENT_TYPE_LIST";

export const SET_TEST_PANEL_LIST = "SET_TEST_PANEL_LIST";
export const GET_TEST_PANEL_LIST = "GET_TEST_PANEL_LIST";

export const GET_BIOMARKER_LIST = "GET_BIOMARKER_LIST";
export const SET_BIOMARKER_LIST = "SET_BIOMARKER_LIST";

export const GET_AGE_LIST = "GET_AGE_LIST";
export const SET_AGE_LIST = "SET_AGE_LIST";

export const GET_ROLE_LIST = "GET_ROLE_LIST";
export const SET_ROLE_LIST = "SET_ROLE_LIST";

export const GET_SYSTEM_CONFIG = "GET_SYSTEM_CONFIG";
export const SET_SYSTEM_CONFIG = "SET_SYSTEM_CONFIG";

export const GET_SAMPLE_TYPES_WITH_COLLECTION_DEVICES="GET_SAMPLE_TYPES_WITH_COLLECTION_DEVICES";
export const SET_SAMPLE_TYPES_WITH_COLLECTION_DEVICES="SET_SAMPLE_TYPES_WITH_COLLECTION_DEVICES";

export const GET_MODULE_PRIMARY_ATTACHMENT= 'GET_MODULE_PRIMARY_ATTACHMENT';
export const SET_MODULE_PRIMARY_ATTACHMENT= 'SET_MODULE_PRIMARY_ATTACHMENT';
export const setInsuranceCompanyData = (data: any[]) => {
    return {
        type: SET_INSURANCE_COMPANY_LIST,
        payload: data
    }
};

export const getInsuranceCompanyData = () => {
    return {
        type: GET_INSURANCE_COMPANY_LIST,
    }
};

export const setInsurancePlanData = (data: any[]) => {
    return {
        type: SET_INSURANCE_PLAN_LIST,
        payload: data
    }
};

export const setSampleCollectionDeviceData = (data: any[]) => {
    return {
        type: SET_SAMPLE_COLLECTION_DEVICE_LIST,
        payload: data
    }
}

export const getSampleCollectionDeviceData = () => {
    return {
        type: GET_SAMPLE_COLLECTION_DEVICE_LIST,
    }
};

export const getReportTypeData = () => {
    return {
        type: GET_REPORT_TYPE_LIST,
    }
};

export const setReportTypeData = (data: any[]) => {
    return {
        type: SET_REPORT_TYPE_LIST,
        payload: data
    }
};
export const getInsurancePlanData = () => {
    return {
        type: GET_INSURANCE_PLAN_LIST,
    }
};

export const setRelationshipData = (data: any[]) => {
    return {
        type: SET_RELATION_SHIP_LIST,
        payload: data
    }
};

export const getRelationshipData = () => {
    return {
        type: GET_RELATION_SHIP_LIST,
    }
};

export const setEthnicityData = (data: any[]) => {
    return {
        type: SET_ETHNICITY_LIST,
        payload: data
    }
};

export const getEthnicityData = () => {
    return {
        type: GET_ETHNICITY_LIST,
    }
};

export const setRaceData = (data: any[]) => {
    return {
        type: SET_RACE_LIST,
        payload: data
    }
};

export const getRaceData = () => {
    return {
        type: GET_RACE_LIST,
    }
};

export const setFacilityTypes = (data: any[]) => {
    return {
        type: SET_FACILITY_TYPES,
        payload: data
    }
}

export const getFacilityTypes = () => {
    return {
        type: GET_FACILITY_TYPES,
    }
}

export const setEquipmentTypeList = (data: any[]) => {
    return {
        type: SET_EQUIPMENT_TYPE_LIST,
        payload: data
    }
}

export const getEquipmentTypeList = () => {
    return {
        type: GET_EQUIPMENT_TYPE_LIST,
    }
}

export const setUserList = (data: any[]) => {
    return {
        type: SET_USER_LIST,
        payload: data
    }
}

export const getUserList = () => {
    return {
        type: GET_USER_LIST,
    }
}

export const setAccountExecutiveList = (data: any[]) => {
    return {
        type: SET_ACCOUNT_EXECUTIVE_LIST,
        payload: data
    }
}

export const getAccountExecutiveList = () => {
    return {
        type: GET_ACCOUNT_EXECUTIVE_LIST,
    }
}

export const setPayorMixList = (data: any[]) => {
    return {
        type: SET_PAYOR_MIX_LIST,
        payload: data
    }
}

export const getPayorMixList = () => {
    return {
        type: GET_PAYOR_MIX_LIST,
    }
}

export const setAccountPreferenceStaticData = (data: any[]) => {
    return {
        type: SET_ACCOUNT_PREFERENCES,
        payload: data
    }
}

export const getAccountPreferenceStaticData = () => {
    return {
        type: GET_ACCOUNT_PREFERENCES,
    }
}

export const setFacilityListLite = (data: any[]) => {
    return {
        type: SET_FACILITY_LIST_LITE,
        payload: data
    }
}

export const getFacilityListLite = () => {
    return {
        type: GET_FACILITY_LIST_LITE,
    }
}

export const setLocationListLite = (data: any[]) => {
    return {
        type: SET_LOCATION_LIST_LITE,
        payload: data
    }
}

export const getLocationListLite = () => {
    return {
        type: GET_LOCATION_LIST_LITE,
    }
}

export const setAllLocationListLite = (data: any[]) => {
    return {
        type: SET_ALL_LOCATION_LIST_LITE,
        payload: data
    }
}

export const getAllLocationListLite = () => {
    return {
        type: GET_ALL_LOCATION_LIST_LITE,
    }
}
export const setLabListLite = (data: any[]) => {
    return {
        type: SET_LAB_LIST_LITE,
        payload: data
    }
}

export const getLabListLite = () => {
    return {
        type: GET_LAB_LIST_LITE,
    }
}

export const setTestOrderStatus = (data: any[]) => {
    return {
        type: SET_TEST_ORDER_STATUS,
        payload: data
    }
}

export const getTestOrderStatus = () => {
    return {
        type: GET_TEST_ORDER_STATUS,
    }
}

export const setTestPanelStatus = (data: any[]) => {
    return {
        type: SET_TEST_PANEL_STATUS,
        payload: data
    }
}

export const getTestPanelStatus = () => {
    return {
        type: GET_TEST_PANEL_STATUS,
    }
}

export const setFacilityStatus = (data: any[]) => {
    return {
        type: SET_FACILITY_STATUS,
        payload: data
    }
}

export const getFacilityStatus = () => {
    return {
        type: GET_FACILITY_STATUS,
    }
}

export const setLocationStatus = (data: any[]) => {
    return {
        type: SET_LOCATION_STATUS,
        payload: data
    }
}

export const getLocationStatus = () => {
    return {
        type: GET_LOCATION_STATUS,
    }
}

export const setLabStatus = (data: any[]) => {
    return {
        type: SET_LAB_STATUS,
        payload: data
    }
}

export const getLabStatus = () => {
    return {
        type: GET_LAB_STATUS,
    }
}

export const setPhysicianListLite = (data: any[]) => {
    return {
        type: SET_PHYSICIAN_LIST_LITE,
        payload: data
    }
}

export const getPhysicianListLite = () => {
    return {
        type: GET_PHYSICIAN_LIST_LITE,
    }
}

export const setCityListLite = (data: any[]) => {
    return {
        type: SET_CITY_LIST_LITE,
        payload: data
    }
}

export const getCityListLite = () => {
    return {
        type: GET_CITY_LIST_LITE,
    }
}

export const setSampleStatusList = (data: any[]) => {
    return {
        type: SET_SAMPLE_STATUS_LIST,
        payload: data
    }
}

export const getSampleStatusList = () => {
    return {
        type: GET_SAMPLE_STATUS_LIST
    }
}

export const setSampleTypesList = (data: any[]) => {
    return {
        type: SET_SAMPLE_TYPES_LIST,
        payload: data
    }
}

export const getSampleTypesList = () => {
    return {
        type: GET_SAMPLE_TYPES_LIST
    }
}

export const getPanelCodeList = () => {
    return {
        type: GET_PANEL_CODE_LIST
    }
}

export const setPanelCodeList = (data: any[]) => {
    return {
        type: SET_PANEL_CODE_LIST,
        payload: data
    }
}

export const getBillingModeList = () => {
    return {
        type: GET_BILLING_MODE_LIST
    }
}

export const setBillingModeList = (data: any[]) => {
    return {
        type: SET_BILLING_MODE_LIST,
        payload: data
    }
}

export const getTestPanelList = () => {
    return {
        type: GET_TEST_PANEL_LIST
    }
}

export const setTestPanelList = (data: any[]) => {
    return {
        type: SET_TEST_PANEL_LIST,
        payload: data
    }
}

export const getTestListLite = () => {
    return {
        type: GET_TEST_LIST_LITE
    }
}

export const setTestListLite = (data: any[]) => {
    return {
        type: SET_TEST_LIST_LITE,
        payload: data
    }
}

export const getExpressionsListLite = () => {
    return {
        type: GET_EXPRESSIONS_LIST_LITE
    }
}

export const setExpressionsListLite = (data: any[]) => {
    return {
        type: SET_EXPRESSIONS_LIST_LITE,
        payload: data
    }
}

export const getBiomarkerList = () => {
    return {
        type: GET_BIOMARKER_LIST
    }
}

export const setBiomarkerList = (data: any[]) => {
    return {
        type: SET_BIOMARKER_LIST,
        payload: data
    }
}

export const getAgeList = () => {
    return {
        type: GET_AGE_LIST
    }
}

export const setAgeList = (data: any[]) => {
    return {
        type: SET_AGE_LIST,
        payload: data
    }
}

export const getRoleList = () => {
    return {
        type: GET_ROLE_LIST
    }
}

export const setRoleList = (data: any[]) => {
    return {
        type: SET_ROLE_LIST,
        payload: data
    }
}

export const getSystemConfig = () => {
    return {
        type: GET_SYSTEM_CONFIG,
    }
}

export const setSystemConfig = (data: any) => {
    return {
        type: SET_SYSTEM_CONFIG,
        payload: data,
    }
}

export const getSampleTypesWithCollectionDevices = () => {
    return {
        type: GET_SAMPLE_TYPES_WITH_COLLECTION_DEVICES,
    }
}

export const setSampleTypesWithCollectionDevices = (data: any[]) => {
    return {
        type: SET_SAMPLE_TYPES_WITH_COLLECTION_DEVICES,
        payload: data,
    }
}

export const getPrefixList = () => {
    return {
        type: GET_PREFIX_LIST,
    }
}

export const setPrefixList = (data: any[]) => {
    return {
        type: SET_PREFIX_LIST,
        payload: data,
    }
}

export const getSuffixList = () => {
    return {
        type: GET_SUFFIX_LIST,
    }
}

export const setSuffixList = (data: any[]) => {
    return {
        type: SET_SUFFIX_LIST,
        payload: data,
    }
}

export const getMaritalStatusList = () => {
    return {
        type: GET_MARITAL_STATUS_LIST,
    }
}

export const setMaritalStatusList=(data:any[])=>{
    return {
        type: SET_MARITAL_STATUS_LIST,
        payload: data
    }
}

export const getModulePrimaryAttachment=()=>{
    return {
        type: GET_MODULE_PRIMARY_ATTACHMENT,
    }
}

export const setModulePrimaryAttachment=(data:ModulePrimaryAttachment)=>{
    return {
        type: SET_MODULE_PRIMARY_ATTACHMENT,
        payload: data
    }
}
